<div
    class="moorl-collapse"
    :class="expanded ? 'expanded' : ''"
>
    <div class="moorl-collapse__header">
        <slot
            name="header"
            v-bind="{ expanded }"
        >
            <h4 @click="collapseItem">{{ label }}</h4>
            <div>
                <slot name="header-content"></slot>
            </div>
            <div @click="collapseItem">
                <mt-icon
                    v-if="expanded"
                    small
                    name="regular-chevron-down-s"
                />
                <mt-icon
                    v-else
                    small
                    name="regular-chevron-right-s"
                />
            </div>
        </slot>
    </div>
    <div
        v-if="expanded"
        class="moorl-collapse__content"
    >
        <slot name="content"></slot>
    </div>
</div>